import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "nameInput", "form"]

  open(event) {
    const button = event.currentTarget
    this.formTarget.action = button.dataset.url
    this.nameInputTarget.value = button.dataset.defaultName || ""
    this.dialogTarget.showModal()
    this.nameInputTarget.focus()
    this.nameInputTarget.select()
  }

  close() {
    this.dialogTarget.close()
  }
}
